import { Link } from "react-router-dom";

import { useTypedDispatch } from "../../../app/redux/hooks/redux";
import { selectArea } from "../../../app/redux/reducers/vacanciesSlice";

import LogoIcon from "../../../app/assets/logo/logo.png";

import styles from "./Logo.module.css";

export const Logo = () => {
  const dispatch = useTypedDispatch();

  return (
    <Link
      to="/vacancies/moscow"
      className={styles["logo__link"]}
      onClick={() => dispatch(selectArea("Москва"))}
    >
      <img
        className={styles["logo__icon"]}
        src={LogoIcon}
        alt="logo-icon"
        width={30}
        height={30}
      />
      <h1 className={styles["logo__title"]}>.FrontEnd</h1>
    </Link>
  );
};
